import {usePreviousRoute} from '@utils/hooks/usePreviousRoute';

export function PreviousRouteTracker() {
    usePreviousRoute();

    return null;
}
